import { reactive, watch } from '@vue/composition-api'

export function useHistory<T>(initialValue: T): {
  value: T
  rollback: () => any
} {
  let prevValue: T = initialValue
  const res = reactive({
    value: initialValue,
    rollback: () => {
      // @ts-ignore
      res.value = prevValue
    },
  })
  watch(
    () => res.value,
    (newValue, oldValue) => {
      // @ts-ignore
      prevValue = oldValue
    },
  )
  // @ts-ignore
  return res
}
